import {
    CLEAR_FILTER,
    PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS, RETURN_TIME_CHANGE, RETURN_TIME_TYPE_CHANGE,
    SET_SELECTED_URL_FILTERS
} from "../../actions/FlightsActions";

export const initialState = {
    type: 'departure',
    start: 0,
    end: 24
};

const ReturnTimeFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case RETURN_TIME_CHANGE:
            return {
                ...state,
                start: action.payload.start === undefined ? state.start : action.payload.start,
                end: action.payload.end === undefined ? state.end : action.payload.end
            };
        case RETURN_TIME_TYPE_CHANGE:
            return {
                ...state,
                type: action.payload
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'returnTime') {
                return {
                    ...state,
                    type: action.payload.type,
                    startSelected: parseInt(action.payload.start, 10),
                    endSelected: parseInt(action.payload.end, 10)
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {...state,
                type: action.filters.returnTime.type,
                start: action.filters.returnTime.start,
                end: action.filters.returnTime.end
            };
        case CLEAR_FILTER:
            if (action.filter === 'returnTime') {
                return {...state, start: initialState.start, end: initialState.end};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, start: initialState.start, end: initialState.end};
        default:
            return state
    }
};

export default ReturnTimeFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/ReturnTimeFilterReducer.js